import { SuccessfulPaymentMethod } from '@mews-commander/data-access';
import { UnicodeEntity } from '@mews/enums';
import { Stack } from '@optimus-web/core';
import { WithAccountId } from '@mews-commander/types';
import { PaymentMethodSidebarLink } from '../PaymentMethods/PaymentMethodSidebarLink';
import { getPaymentMethodIcon, getPaymentMethodTitle, mapToSupportedPaymentMethod } from './utils';

export const PaymentRequestMethodCell = ({
    paymentMethodId,
    paymentMethodType,
    identifierLast4Digits,
    creditCardType,
    accountId,
}: SuccessfulPaymentMethod & WithAccountId) => {
    const icon = getPaymentMethodIcon(paymentMethodType, creditCardType);
    const title = getPaymentMethodTitle(paymentMethodType, creditCardType);
    const supportedPaymentMethod = mapToSupportedPaymentMethod(paymentMethodType);

    const content = (
        <Stack itemAlignment="center">
            {icon}
            {UnicodeEntity.NoBreakSpace}
            <Stack itemAlignment="center">
                {identifierLast4Digits && (
                    <>
                        {UnicodeEntity.NoBreakSpace}
                        {identifierLast4Digits}
                    </>
                )}
            </Stack>
        </Stack>
    );

    if (!supportedPaymentMethod || !paymentMethodId) {
        return content;
    }

    return (
        <PaymentMethodSidebarLink
            paymentMethod={supportedPaymentMethod}
            paymentMethodId={paymentMethodId}
            accountId={accountId}
            sidebarTitle={
                <Stack itemAlignment="center">
                    {title}
                    {identifierLast4Digits && (
                        <>
                            {UnicodeEntity.NoBreakSpace}
                            {identifierLast4Digits}
                        </>
                    )}
                </Stack>
            }
            linkTitle={content}
        />
    );
};
